/**
* description:
* File of container Complains Container
*
* data : 2017-08-03
*/

import Vue from 'vue';
import store from '@/store';
import { mapGetters } from 'vuex';

// COMPONENTS //////////////////////////////////////////////////////////////////
import ComplainsCTA from '@/components/Complains/ComplainsCTA';
import ComplainsForm from '@/components/Complains/ComplainsForm';
import ComplainsInfo from '@/components/Complains/ComplainsInfo';

// CONTAINER ///////////////////////////////////////////////////////////////////
const Complains = {
  components: { ComplainsCTA, ComplainsForm, ComplainsInfo },
  store,
  computed: {
    ...mapGetters(['settings', 'subscriber', 'complainsFormHasBeenSent', 'pendingStoreActions']),
  },
  template: `
    <div class="container-fluid animated fadeIn">
      <div class="row">
        <div class="col-xs-12 col-md-5">
          <complains-c-t-a />
        </div>
        <div class="col-xs-12 col-md-7">
          <complains-form
            :settings="settings" 
            :subscriber="subscriber" 
            :complains-form-has-been-sent="complainsFormHasBeenSent" 
            :is-loading-data="pendingStoreActions.includes('sendComplainsForm')"
            :form-name="'reports'"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <complains-info />
        </div>
      </div>
    </div>
  `,
};

export default Vue
  .component('Complains', Complains);



// WEBPACK FOOTER //
// ./src/containers/Complains/index.js